import { MutationTree } from "vuex";
import { RootState } from "./state";
import { MY_JLS_TOKEN } from "@/constants/local-storage-keys";
import { FormValues } from "@/interfaces/FormValues";

export interface SinglePagePayload {
  PAGE_NAME: string;
  formValues: FormValues;
}

export const mutations: MutationTree<RootState> = {
  setFormValues(state, payload: SinglePagePayload) {
    state.allFormValues[payload.PAGE_NAME] = payload.formValues;
  },

  resetFormValues(state) {
    state.allFormValues = {};
  },

  setMyJLSToken(state, payload: string) {
    state.myJLSToken = payload;
    // also set in local storage
    localStorage.setItem(MY_JLS_TOKEN, payload);
  },

  setUserName(state, payload: string) {
    state.userName = payload;
  },

  setBankName(state, payload: string) {
    state.bankName = payload;
  },
};
